// extracted by mini-css-extract-plugin
export default {"reviewHistoryModal":"ReviewModal_reviewHistoryModal__1eT4O"};